/**
 * 键名为中文（与代码中 $T('…') 一致），值为英文展示文案。
 */
export default {
  '报名': 'Register',
  '未开始': 'Not started',
  '正在报名': 'Open for registration',
  '报名结束': 'Registration closed',
  '正在比赛': 'In progress',
  '已结束': 'Ended',
  '线下': 'Offline',
  '请选择语言': 'Select language',
  '中文': 'Chinese',
  '英文': 'English',
  '当前界面语言': 'Interface language',
  '南京': 'Nanjing',

  // MineLayout 个人中心侧栏
  '个人中心': 'My account',
  '资料修改': 'Edit profile',
  '基本信息': 'Basic information',
  '用户名': 'Username',
  '注册时间': 'Registered',
  '登录密码': 'Password',
  '密码安全提示': 'A strong password keeps your account safer. We recommend changing it regularly.',
  '修改': 'Change',
  '密码': 'Password',
  '重复密码': 'Confirm password',
  '手机号': 'Mobile number',
  '请输入用户名': 'Enter username',
  '请输入密码': 'Enter password',
  '请输入中国大陆手机号': 'Enter a mainland China mobile number',
  '请输入验证码': 'Enter verification code',
  '验证码': 'Verification code',
  '提交': 'Submit',
  '还原': 'Reset',
  '提示': 'Notice',
  '正在建设中~': 'Under construction.',
  '正在建设中哦~': 'Under construction.',
  '赛事活动': 'Events',
  '退出登录': 'Sign out',
  '确定退出吗？': 'Are you sure you want to sign out?',

  // Password.vue 修改密码
  '修改密码': 'Change password',
  '当前密码': 'Current password',
  '新密码': 'New password',
  '确认新密码': 'Confirm new password',
  '请输入当前密码': 'Enter your current password',
  '请输入新密码': 'Enter a new password',
  '请再次输入新密码': 'Enter the new password again',
  '新密码至少6位': 'New password must be at least 6 characters',
  '两次新密码不一致': 'The two new passwords do not match',
  '两次新密码输入不一致': 'The two new passwords do not match.',
  '密码修改成功': 'Password updated',
  '当前密码错误': 'Incorrect current password.',
  '新密码不能与当前密码相同': 'New password must be different from your current password.',
  '不好意思出错啦': 'Something went wrong. Please try again.',

  // SaiApplyFormStep1 报名联系人
  '联系人': 'Contact person',
  '姓': 'Surname',
  '名': 'Given name',
  '请输入姓名': 'Please enter your name',
  '邮箱': 'Email',
  '请输入邮箱': 'Please enter your email',
  '电话': 'Phone',
  '区号': 'Code',
  '请输入电话号码': 'Please enter phone number',
  '地址': 'Address',
  '请输入协会地址': 'Please enter organization address',
  '下一步': 'Next',
  '请选择地区代码': 'Please select country/region code',
  '请输入手机号': 'Please enter phone number',
  '手机号格式不正确': 'Invalid phone number format',
  '请输入正确的邮箱': 'Please enter a valid email',
  '邮箱格式不正确': 'Invalid email format',
  '秩序册填写': 'Program book',
  '建议您选择继续未完成的报名': 'We recommend continuing your unfinished registration.',
  '您有未完成的报名': 'You have an unfinished registration.',
  '继续未完成的报名': 'Continue registration',
  '重新报名': 'Start over',
  '等待认证': 'Pending verification',
  '查看详情': 'View details',

  // 电话国家/地区（与 SaiApplyFormStep1 下拉一致）
  '中国': 'China',
  '美国': 'United States',
  '西班牙': 'Spain',
  '英国': 'United Kingdom',
  '意大利': 'Italy',
  '哈萨克斯坦': 'Kazakhstan',
  '以色列': 'Israel',
  '捷克': 'Czech Republic',
  '日本': 'Japan',
  '瑞典': 'Sweden',
  '加拿大': 'Canada',
  '巴西': 'Brazil',
  '保加利亚': 'Bulgaria',
  '南非': 'South Africa',
  '澳大利亚': 'Australia',
  '墨西哥': 'Mexico',
  '法国': 'France',
  '哥伦比亚': 'Colombia',
  '新加坡': 'Singapore',
  '丹麦': 'Denmark',
  '瑞士': 'Switzerland',
  '乌兹别克斯坦': 'Uzbekistan',
  '葡萄牙': 'Portugal',
  '埃及': 'Egypt',
  '新西兰': 'New Zealand',
  '德国': 'Germany',
  '希腊': 'Greece',
  '阿根廷': 'Argentina',
  '中国香港': 'Hong Kong, China',
  '阿尔及利亚': 'Algeria',
  '乌克兰': 'Ukraine',
  '荷兰': 'Netherlands',
  '比利时': 'Belgium',
  '奥地利': 'Austria',
  '格鲁吉亚': 'Georgia',
  '阿塞拜疆': 'Azerbaijan',
  '土耳其': 'Turkey',
  '爱沙尼亚': 'Estonia',
  '秘鲁': 'Peru',
  '爱尔兰': 'Ireland',
  '波兰': 'Poland',
  '俄罗斯': 'Russia',
  '白俄罗斯': 'Belarus',
  '斯洛伐克': 'Slovakia',
  '芬兰': 'Finland',
  '中国台北': 'Chinese Taipei',
  '纳米比亚': 'Namibia',
  '塔吉克斯坦': 'Tajikistan',
  '印度': 'India',
  '菲律宾': 'Philippines',

  // SaiApplyDetail 报名进度
  '填写秩序册': 'Program book',
  '联系人、邮箱与电话': 'Contact, email and phone',
  '修改信息': 'Edit',
  '人员信息': 'Team members',
  '队伍成员与证件': 'Roster and ID documents',
  '上传/修改音乐': 'Upload / edit music',
  '继续操作': 'Continue',
  '住宿预订': 'Accommodation',
  '酒店与房型': 'Hotel and room type',
  '线上赛区无需填写': 'Not required for online events',
  '餐饮预订': 'Meals',
  '用餐与套餐': 'Meals and packages',
  '接送服务': 'Pickup & drop-off',
  '接机/送站': 'Airport / station transfer',
  '接送单价说明': 'USD/person (round trip included). Per station: billed passengers = max(total arrivals, total departures) × unit price.',
  '接送计费人数': 'Billed passengers',
  '到达合计': 'Arrivals total',
  '离港合计': 'Departures total',
  '站点小计': 'Station subtotal',
  '签证邀请': 'Visa invitation',
  '签证信息填报': 'Visa information',
  '国歌上传': 'National anthem',
  '队伍国歌音频': 'Team anthem & national flag',
  '报名完成': 'Registration complete',
  '报名与后续事项': 'Follow-up items',
  '上传视频': 'Upload video',
  '视频已上传': 'Video uploaded',

  // SaiApplyFormStep2 人员表
  '添加成员': 'Add member',
  '职能': 'Role',
  '全名': 'Full name',
  '出生日期': 'Birth date',
  'FIG执照': 'FIG license',
  '护照号码': 'Passport number',
  '护照PDF': 'Passport PDF',
  '已上传': 'Uploaded',
  '护照到期日': 'Passport expiry date',
  '国籍': 'Citizenship',
  '照片': 'Photo',
  '请上传照片': 'Please upload a photo',
  '保险': 'Insurance',
  '操作': 'Actions',
  '编辑': 'Edit',
  '删除': 'Delete',
  '保存': 'Save',
  '编辑成员': 'Edit member',
  '选择职能': 'Select role',
  '选择国籍': 'Select citizenship',
  '取消': 'Cancel',
  '确定': 'OK',
  '请选择职能': 'Please select a role',
  '请输入全名': 'Please enter full name',
  '请选择出生日期': 'Please select birth date',
  '请输入FIG执照': 'Please enter FIG license',
  '没有证件号用0代替': 'If you do not have an ID number, enter 0.',
  '请输入护照号码': 'Please enter passport number',
  '请选择护照到期日': 'Please select passport expiry date',
  '请选择国籍': 'Please select citizenship',
  '体操运动员': 'Gymnast',
  '教练': 'Coach',
  '裁判': 'Judge',
  '队伍经理': 'Team manager',
  '成员职能体操运动员': 'Gymnast',
  '成员职能代表团团长': 'Heads of delegation',
  '成员职能联合会主席及嘉宾': 'NF President and NF President guest',
  '成员职能联合会主席及嘉宾VIP': 'NF President and NF President guest VIP',
  '成员职能医生': 'Medical doctor',
  '成员职能心理健康专业人员': 'Mental Health Professional',
  '成员职能嘉宾': 'Guest',
  '成员职能嘉宾VIP': 'Guest VIP',
  '成员职能蹦床队经理': 'Team manager (TRA)',
  '成员职能蹦床教练': 'Coach (TRA)',
  '成员职能蹦床医务保障': 'Paramedical staff (TRA)',
  '成员职能蹦床高级裁判': 'TRA Senior Judge',
  '成员职能技巧队经理': 'Team manager (TUM)',
  '成员职能技巧教练': 'Coach (TUM)',
  '成员职能技巧医务保障': 'Paramedical staff (TUM)',
  '成员职能技巧高级裁判': 'TUM Senior Judge',
  '成员职能双杠队经理': 'Team manager (DMT)',
  '成员职能双杠教练': 'Coach (DMT)',
  '成员职能双杠医务保障': 'Paramedical staff (DMT)',
  '成员职能双杠高级裁判': 'DMT Senior Judge',
  '确定删除该成员？': 'Delete this member?',
  '请至少添加一名成员': 'Please add at least one member',
  '保存成功': 'Saved successfully',
  '保存失败': 'Save failed',
  '暂无数据': 'No data',
  '点击上传': 'Click to upload',

  // SaiApplyFormStep3 住宿预订
  '添加房间': 'Add room',
  '复制': 'Copy',
  '序号': '#',
  '预订酒店': 'Reserved hotel',
  '请选择酒店': 'Please select hotel',
  '房型': 'Room type',
  '请选择房型': 'Please select room type',
  '入住日期': 'Check-in',
  '退房日期': 'Check-out',
  '数量': 'Quantity',
  '人员': 'Guests',
  '酒店房型': 'Hotel & room',
  '入住退房': 'Dates',
  '激活即列出输入建议': 'Focus to list suggestions',
  '激活即列出输入建议': 'Focus to list suggestions',
  '人员1': 'Guest 1',
  '人员2': 'Guest 2',
  '请填写入住人员': 'Please enter guest name',
  '请选择入住人员': 'Please select or enter guest',
  '请选择人员1和人员2': 'Please select Guest 1 and Guest 2',
  '请填写人员1和人员2': 'Please enter Guest 1 and Guest 2',
  '同一房间不能选择相同人员': 'Guest 1 and Guest 2 cannot be the same',
  '房间数': 'Rooms',
  '价格': 'Price',
  '总数量': 'Total quantity',
  '总价': 'Total price',
  '加载失败': 'Load failed',
  '请选择入住退房日期': 'Please select check-in and check-out dates',
  '退房须晚于入住': 'Check-out must be after check-in',
  '房间分配': 'Room assignment',
  '已分配': 'Assigned',
  '请先完成住宿预订': 'Please complete accommodation booking first',

  // SaiApplyFormStep4 餐饮预订
  '添加预约': 'Add reservation',
  '清空全部': 'Clear all',
  '场地': 'Venue',
  '请选择场地': 'Please select venue',
  '套餐类型': 'Meal package',
  '请选择套餐': 'Please select meal package',
  '用餐日期': 'Serve date',
  '小计': 'Subtotal',
  '状态': 'Status',
  '草稿': 'Draft',
  '请选择用餐日期': 'Please select serve date',
  '暂无餐饮预订，可点击添加或直接下一步清空': 'No meal bookings. Add one, or continue to clear all.',
  '确认清空全部餐饮预订？清空后需点下一步才会保存': 'Clear all meal bookings? Click Next to save the change.',
  '当前没有餐饮预订，确认取消全部餐饮预订并继续？': 'No meal bookings selected. Cancel all meal bookings and continue?',
  '已取消全部餐饮预订': 'All meal bookings have been cancelled',

  // SaiApplyFormStep5 接送
  '添加接送': 'Add transfer',
  '行程类型': 'Trip type',
  '请选择行程类型': 'Please select trip type',
  '到达': 'Arrival',
  '离港': 'Departure',
  '出行日期': 'Travel date',
  '请选择出行日期': 'Please select travel date',
  '航班车次号': 'Flight / train no.',
  '请输入航班车次号': 'Enter flight or train number',
  '机场站点': 'Airport / station',
  '请选择机场站点': 'Please select airport or station',
  '人数': 'Passengers',
  '行李件数': 'Luggage (pieces)',

  // SaiApplyFormStep6 签证邀请
  '签证政策参考': 'Visa policy reference',
  '签证参考互免协定一览': "List of Agreements on Mutual Visa Exemption Between the People's Republic of China and Foreign Countries",
  '签证参考单方面免签': 'FAQs on Visa-free Entry into China',
  '签证邀请信息': 'Visa invitation',
  '添加签证': 'Add visa',
  '性别': 'Gender',
  '男': 'Male',
  '女': 'Female',
  '申请城市': 'City to apply',
  '请输入申请城市': 'Enter city to apply',
  '抵达日期': 'Arrival date',
  '离境日期': 'Departure date',
  '编辑签证邀请': 'Edit visa invitation',
  '新增签证邀请': 'Add visa invitation',
  '请输入姓': 'Please enter surname',
  '请输入名': 'Please enter given name',
  '请选择性别': 'Please select gender',
  '已更新': 'Updated',
  '已添加': 'Added',
  '请完善姓名': 'Please complete name',
  '请完善出生日期': 'Please complete date of birth',

  // SaiApplyFormStep7 国歌/国旗上传
  '国歌上传说明': 'Upload audio file(s) for your team’s national anthem (e.g. MP3, WAV, or M4A).',
  '音频文件': 'Audio files',
  '国旗': 'National flag',
  '国旗上传说明': 'Upload image file(s) of your national flag (e.g. JPG, PNG).',

  // SaiApplyList 报名列表
  '我报名的赛事': 'My event registrations',
  '报名中': 'In progress',
  '报名成功': 'Completed',
  '全部': 'All',
  '报名人数': 'Roster',
  '等待付款': 'Pending payment',
  '接送签证国歌': 'Transfer, visa & anthem',
  '报名详情': 'Details',
  '下载证书': 'Download certificate',
  '补缴费用': 'Supplemental payment',
  '提交文件': 'Submit files',
  '报名信息': 'Registration info',
  '报名记录': 'Registration history',
  '我的报名记录': 'My registrations',
  '报名草稿': 'Draft',
  '确定删除报名记录': 'Delete this registration? This cannot be undone.',
  '确认': 'Confirm',

  // IndexPc 蹦床世锦赛官网首页
  '敬请期待': 'Coming soon !',
  '官网公告栏标题': 'Notice',
  '2026年全国蹦床锦标赛暨南京世锦赛测试赛成功举办':
    '2026 National Trampoline Championships and Nanjing Worlds Test Event Successfully Held',
  '南京世锦赛和世青赛、年龄组比赛确认报名工作结束，参赛队伍数量和人数情况。':
    'Entry confirmation has closed for the Nanjing World Championships, Junior Worlds and Age Group Competitions, with team and athlete totals.',
  '官网页面标题': '2026 World Trampoline Championships',
  '官网页面描述':
    '2026 Trampoline World Championships in Nanjing, China — FIG trampoline gymnastics.',
  '官网菜单竞赛': 'COMPETITION',
  '官网菜单新闻资讯': 'NEWS & INFO',
  '官网菜单代表团': 'DELEGATION',
  '官网菜单票务': 'TICKETING',
  '官网菜单观众中心': 'SPECTATOR CENTER',
  '官网菜单商务': 'BUSINESS',
  '官网菜单赞助商': 'SPONSORS',
  '官网菜单城市文化': 'CITY & CULTURE',
  '官网菜单世青赛全称':
    'Junior World Championships and World Age Group Competitions',
  '官网菜单世锦赛全称': '2026 Trampoline World Championships',
  '年龄组关于赛事水印大标题': 'ABOUT THE COMPETITIONS',
  '年龄组关于赛事章节标题': 'About the Competitions',
  '年龄组关于赛事小节标题':
    'Junior World Championships and World Age Group Competitions',
  '年龄组关于赛事段落1':
    'The 3rd FIG Trampoline & Tumbling Gymnastics Junior World Championships and 32nd World Age Group Competitions will take place in Nanjing, China, bringing together the world\'s most promising young trampoline gymnasts for an exceptional showcase of talent and dedication.',
  '年龄组关于赛事段落2':
    'Sanctioned by the International Gymnastics Federation (FIG), these companion events spotlight the future of the sport. The Junior World Championships are open to athletes aged 15–16, while the World Age Group Competitions welcome gymnasts across established age categories in Individual and Synchronized Trampoline, Tumbling, and Double Mini-Trampoline.',
  '年龄组关于赛事段落3':
    'Representatives of national federations from around the world will compete for championship titles, displaying remarkable technique, consistency, and breathtaking performances in the air.',
  '年龄组官网页面标题':
    '2026 Junior World Championships and World Age Group Competitions',
  '年龄组官网页面描述':
    '2026 FIG Junior World Championships and World Age Group Competitions in Nanjing, China — trampoline, tumbling, and double mini-trampoline for young athletes.',
  '年龄组官网页脚版权':
    '© 2026 Junior World Championships and World Age Group Competitions · Nanjing',
  '年龄组官网页脚副标题':
    'Hosted in Nanjing Jiangbei New Area | November 12–15, 2026',
  '关于赛事水印大标题': 'ABOUT THE CHAMPIONSHIPS',
  '关于赛事章节标题': 'About the Championships',
  '关于赛事小节标题': 'Trampoline World Championships 2026',
  '关于赛事段落1':
    'The 2026 Trampoline World Championships will be held in Nanjing, China, bringing together the world\'s elite trampoline gymnasts for an extraordinary display of athleticism and artistry.',
  '关于赛事段落2':
    'This prestigious event, organized by the International Gymnastics Federation (FIG), showcases the pinnacle of trampoline gymnastics, featuring individual and synchronized competitions across multiple disciplines.',
  '关于赛事段落3':
    'Athletes from over 50 nations will compete for the coveted world championship titles, demonstrating incredible skills, technical precision, and breathtaking aerial performances.',
  '官网倒计时天': 'DAYS',
  '官网倒计时时': 'HOURS',
  '官网倒计时分': 'MINUTES',
  '官网倒计时秒': 'SECONDS',
  '最新新闻水印': 'LATEST NEWS',
  '最新新闻标题': 'Latest News',
  '新闻阅读更多': 'Read More',
  '官网新闻1日期': 'March 9, 2026',
  '官网新闻1标题':
    '2026 Trampoline World Championships Officially Confirmed to Be Held in Nanjing',
  '官网新闻1摘要':
    'The 39th FIG Trampoline World Championships will take place at Yangtze River International Conference Center in Nanjing Jiangbei New Area from November 5 to 8, gathering top trampoline athletes worldwide for elite aerial competitions.',
  '官网新闻2日期': 'October 25, 2025',
  '官网新闻2标题':
    "FIG Secretary-General Praises China's Event Organization for 2026 Nanjing Trampoline Worlds",
  '官网新闻2摘要':
    "FIG Secretary-General highly recognizes China's outstanding hosting capacity and expresses full anticipation for the successful holding of the 2026 Trampoline World Championships in Nanjing.",
  '官网新闻3日期': 'November 10, 2025',
  '官网新闻3标题':
    'Chinese Trampoline Team Wins 4 Golds, Eyeing Home Glory at 2026 Nanjing Worlds',
  '官网新闻3摘要':
    "China's trampoline team claimed 4 golds and 2 bronzes at the 38th Trampoline World Championships, getting fully prepared to defend its strength at the 2026 home tournament in Nanjing.",
  '南京区块眉题': 'HIGH LIVABILITY',
  '南京区块主标题': 'Welcome to Nanjing Jiangbei New Area',
  '南京区块小节标题': 'Urban Area Graced by Mountains and Rivers',
  '南京区块段落1':
    "The Yangtze River's winding course, a silken thread, and stretches Mount Laoshan's expansive verdant beauty, framing the new district in a panorama of waters and peaks. Backed by Mount Laoshan's serene majesty and embraced by the Yangtze River's grand sweep, this is truly a natural landscape masterpiece tailored for refined living.",
  '南京区块段落2':
    'Here, the harmony of mountains, water and the city converges into an ever-changing tableau—a tranquil retreat woven into the urban fabric, where vibrancy meets serenity in a landscape of mountains, rivers, and cityscape.',
  '合作伙伴水印': 'OFFICIAL PARTNERS',
  '合作伙伴标题': 'OFFICIAL PARTNERS',
  '官网页脚版权': '© 2026 Trampoline World Championships Nanjing',
  '官网页脚副标题':
    'Hosted in Nanjing Jiangbei New Area | November 5–8, 2026',
  '官网页脚敬请期待': 'Stay tuned!',
  '官网页脚隐私': 'Privacy Policy',
  '官网页脚条款': 'Terms & Conditions',
  '官网页脚联系': 'Contact Us',
  '官网页脚媒体': 'Media',

  // Login.vue
  '登录页标题': 'Sign in',
  '登录': 'Sign in',
  '注册': 'Register',
  '账号': 'Account',
  '忘记密码': 'Forgot password',
  '返回登录': 'Back to sign in',
  '获取验证码': 'Get code',
  '发送成功': 'Sent successfully',
  '登录成功': 'Signed in successfully',
  '注册成功': 'Registration successful',
  '请再次确认密码': 'Confirm your password again',
  '单位名': 'Organization name',
  '单位名称': 'Organization name',
  '请输入用户名/手机': 'Enter username or mobile number',
  '长度在11个字符': 'Must be exactly 11 digits',
  '长度在4个字符': 'Must be exactly 4 characters',
  '长度在3-16个字符': 'Must be 3–16 characters',
  '请再次输入密码': 'Enter password again',
  '手机不能为空': 'Mobile number is required',
  '手机号码必须为11位': 'Mobile number must be 11 digits',
  '验证码须为4位': 'Verification code must be 4 characters',
  '请输入重置密码': 'Enter new password',
  '请再次输入重置密码': 'Enter new password again',
  '请登录': 'Please sign in.',
  '验证通过请重置密码': 'Verified. Please set a new password.',
  '两次密码不一致': 'Passwords do not match.',
  '单位用户名密码不能为空':
    'Organization, username and password are required.',
  '密码确认错误': 'Password confirmation does not match.',
  '内容不能为空': 'Please fill in all fields.',

  // Login /api/index/* 服务端返回 msg（中文键）
  '用户不存在': 'User not found.',
  '密码错误': 'Incorrect password.',
  '请输入用户名或者手机号': 'Enter username or mobile number.',
  '请输入正确格式的手机号': 'Enter a valid mobile number.',
  '验证码错误或已过期': 'Invalid or expired verification code.',
  '请1分钟后再试': 'Please wait one minute before trying again.',
  '用户名不能为纯数字': 'Username cannot be all numbers.',
  '用户名不能是纯数字': 'Username cannot be all numbers.',
  '用户名已被注册': 'This username is already registered.',
  '用户名已存在': 'This username already exists.',
  '手机号已被注册': 'This mobile number is already registered.',
  '手机号已存在': 'This mobile number already exists.',
  '账号密码不可为空': 'Account and password are required.',

  // 线下汇款备注
  '备注信息': 'Payment note',
  '汇款信息': 'Remittance info',
  '汇款时间': 'Remittance date',
  '请输入汇款时间': 'Please enter remittance date',
  '汇款单号': 'Remittance number',
  '请输入汇款单号': 'Please enter remittance number',
  '线下支付凭证': 'Offline payment voucher',
  '上传支付凭证': 'Upload payment voucher',
  '请上传支付凭证': 'Please upload payment voucher',
  '确定提交': 'Submit',
};



// WEBPACK FOOTER //
// ./src/i18n/messages/en-US.js